import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
//引入组件自动化注册
import "./utils/register.js";
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
